var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2162_7057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7008 14.419C20.3651 19.7762 14.9385 23.0365 9.58005 21.7006C4.22386 20.365 0.96321 14.9387 2.29952 9.58197C3.63465 4.22419 9.06123 0.963662 14.418 2.29923C19.7761 3.63481 23.0365 9.0617 21.7006 14.4191L21.7007 14.419H21.7008Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4099 10.5748C16.609 9.24401 15.5957 8.52866 14.2101 8.05146L14.6596 6.2488L13.5622 5.97537L13.1246 7.73057C12.8361 7.65862 12.5398 7.59082 12.2453 7.52361L12.6861 5.75683L11.5893 5.4834L11.1396 7.28547C10.9008 7.23112 10.6663 7.1774 10.4388 7.1208L10.4401 7.11513L8.92665 6.73724L8.63471 7.90927C8.63471 7.90927 9.44893 8.09589 9.43177 8.10737C9.87618 8.21828 9.95655 8.51244 9.9432 8.74559L9.43118 10.7992C9.46179 10.807 9.50148 10.8183 9.54528 10.8359C9.50867 10.8268 9.46971 10.8168 9.42928 10.8072L8.7116 13.684C8.65729 13.819 8.51944 14.0216 8.20873 13.9447C8.21973 13.9606 7.41108 13.7457 7.41108 13.7457L6.86621 15.0018L8.29437 15.3578C8.56006 15.4244 8.82042 15.4941 9.07682 15.5596L8.62268 17.383L9.71887 17.6564L10.1686 15.8524C10.4681 15.9337 10.7587 16.0087 11.0432 16.0794L10.595 17.8748L11.6925 18.1483L12.1466 16.3283C14.018 16.6825 15.4251 16.5397 16.0174 14.8472C16.4947 13.4846 15.9936 12.6986 15.0091 12.186C15.7262 12.0207 16.2663 11.5491 16.4103 10.5749L16.41 10.5747L16.4099 10.5748ZM13.9025 14.0905C13.5633 15.4531 11.2688 14.7165 10.5249 14.5318L11.1275 12.1162C11.8714 12.3019 14.257 12.6694 13.9026 14.0905H13.9025ZM14.2419 10.555C13.9325 11.7945 12.0228 11.1648 11.4032 11.0104L11.9496 8.81959C12.5691 8.974 14.5642 9.26219 14.242 10.555H14.2419Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2162_7057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinIcon);
export default __webpack_public_path__ + "static/media/bitcoin-icon.617d8b92b976d593f509ddb397bcdc74.svg";
export { ForwardRef as ReactComponent };